// src/utils/companyTypes.js
//
// Frontend mirror of backend src/utils/companyTypes.js.
//
// 'grain_mill' (gandum ka godown + manufacturing) flour_mill ke saath SAME behavior
// share karta hai (isFlourMill() dono par true), lekin apna alag company_type / sidebar hai.
//
// 'flour_mill' (gandum kharid kar us se products banane wali companies)
// abhi 'manufacturer' ke saath SAME pages / routes / permission screens
// share karta hai, lekin ye alag company_type hai (alag sidebar menu
// backend se aata hai). Jab kisi page ko sirf flour mill ya sirf
// manufacturer ke liye alag karna ho, wahan isManufacturerFamily() ki
// jagah seedha isFlourMill() / === COMPANY_TYPES.MANUFACTURER lagao.

export const COMPANY_TYPES = Object.freeze({
  WHOLESALER: 'wholesaler',
  RETAILER: 'retailer',
  RESTAURANT: 'restaurant',
  DISTRIBUTOR: 'distributor',
  MANUFACTURER: 'manufacturer',
  FLOUR_MILL: 'flour_mill',
  MANUFACTURING_2: 'manufacturing_2',
  GRAIN_MILL: 'grain_mill'
});

export const MANUFACTURER_FAMILY = Object.freeze([
  COMPANY_TYPES.MANUFACTURER,
  COMPANY_TYPES.FLOUR_MILL,
  COMPANY_TYPES.MANUFACTURING_2,
  COMPANY_TYPES.GRAIN_MILL
]);

// true for 'manufacturer', 'flour_mill', 'manufacturing_2' AND 'grain_mill'
export const isManufacturerFamily = (companyType) => MANUFACTURER_FAMILY.includes(companyType);

export const isRetailer = (companyType) => companyType === COMPANY_TYPES.RETAILER;

// Company ceiling -> role defaults -> user override wala permission system:
// manufacturer family + retailer. (isManufacturerFamily ko retailer se mat milao —
// us se manufacturer ke baaqi pages/menus retailer par lag jayenge.)
export const isCeilingPermissionType = (companyType) => isManufacturerFamily(companyType) || isRetailer(companyType);

export const MANUFACTURER_PERMISSION_ROLES = Object.freeze([
  { value: 'admin', label: 'Admin' },
  { value: 'manager', label: 'Manager' },
  { value: 'accountant', label: 'Accountant' },
  { value: 'operator', label: 'Operator' }
]);

export const RETAILER_PERMISSION_ROLES = Object.freeze([
  { value: 'admin', label: 'Admin' },
  { value: 'manager', label: 'Manager' },
  { value: 'cashier', label: 'Cashier' },
  { value: 'staff', label: 'Staff' },
  { value: 'viewer', label: 'Viewer' }
]);

// Permission screens ke role pills company type ke hisaab se
export const getRolesForCompanyType = (companyType) =>
  isRetailer(companyType) ? RETAILER_PERMISSION_ROLES : MANUFACTURER_PERMISSION_ROLES;

// 'grain_mill' (gandum ka godown + manufacturing) shuru me flour_mill jaisa hi chalta hai
// (same pages / routes / sidebar structure), isliye isFlourMill() ab flour_mill AUR
// grain_mill dono ke liye true deta hai. Sirf grain_mill ko alag karna ho to isGrainMill().
export const isFlourMill = (companyType) =>
  companyType === COMPANY_TYPES.FLOUR_MILL || companyType === COMPANY_TYPES.GRAIN_MILL;

export const isGrainMill = (companyType) => companyType === COMPANY_TYPES.GRAIN_MILL;

// 'manufacturing_2': manufacturer jaisa, lekin Packing/Raw ke 2 dropdown ki jagah
// ek Purchase dropdown (Raw / Packing toggle ke saath, /manufacturing2/* pages).
export const isManufacturing2 = (companyType) => companyType === COMPANY_TYPES.MANUFACTURING_2;

export const COMPANY_TYPE_LABELS = Object.freeze({
  wholesaler: 'Wholesaler',
  retailer: 'Retailer',
  restaurant: 'Restaurant',
  distributor: 'Distributor',
  manufacturer: 'Manufacturer',
  flour_mill: 'Flour Mill',
  manufacturing_2: 'Manufacturing 2',
  grain_mill: 'Grain Mill'
});
